import React from "react";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const UserRoleLabel = ({ user }) => {
  const getUserRoleLabel = () => {
    if (user.isCCO) return "app.enuns.levelName.CCO";
    if (user.isSalesDirector) return "app.enuns.levelName.SALES_DIRECTOR";
    if (user.isRegionalManager) return "app.enuns.levelName.REGIONAL_MANAGER";
    if (user.isManager) return "app.enuns.levelName.AGENT_MANAGER";
    if (user.isAgent) return "app.enuns.levelName.AGENT";
    return user.role ? `app.enuns.ROLE_${user.role}` : "";
  };

  return (
    <Typography variant="body1" color="textPrimary">
      <FormattedMessage id={getUserRoleLabel()} />
    </Typography>
  );
};

export default UserRoleLabel;
